
import { Component, Vue } from "vue-property-decorator";
import { USER_TAB_lINKS } from "@/constant";
import General from "@/components/portal/superAdmin/clients/updateClient/UpdateClient.vue";
import AccessRight from "@/views/accessRights/AccessRights.vue";
import Uploader from "@/views/uploader/Uploader.vue";
import UpdateCredential from "@/views/updateCredentials/UpdateCredentials.vue";

@Component({ components: { General, AccessRight, UpdateCredential, Uploader } })
export default class AddClientComponent extends Vue {
  public tabLinks = USER_TAB_lINKS;
  public nextTab: any = null;
  public index: any = null;
  public editing = false;
  public userId = null;

  public get currentTab() {
    return this.$store.state.currentTab;
  }
  async cancelForm() {
    await this.$store.dispatch("cancelUserForm");
    this.$router.go(-1);
  }
  /*********************************************************************************
   *    Change Active tab                                                         *
   *********************************************************************************/
  public async goToTab(value, leave) {
      if (leave) {
        this.tabLinks.forEach(async (tab, tabIndex) => {
          if (tab.value == value) {
            tab.class = "active";
            await this.$store.dispatch("updateStore", { currentTab: value });
          } else {
            tab.class = "";
          }
        });
      }
  }

  /*****************************************************************************************************
   *            Save every tab information on tab switch                                              *
   ****************************************************************************************************/
  public async saveEveryTabInformation(tabName) {
      if (tabName && this.$refs[tabName])
        return await this.$refs[tabName]["saveInformation"]();
  }

  /***************************************************************************************
   *              Change tab on click or validate existing tab data.                     *
   ***************************************************************************************/
  public async tabChange(value) {
    if (value != this.currentTab) {
      let data = await this.saveEveryTabInformation(this.currentTab);
      if (data.status) {
        this.goToTab(value, true);
      }
    }
  }

  async mounted() {
    this.editing = this.$route.query.userId ? true : false;
    if (this.editing)
      await this.$store.dispatch("getClient", this.$route.query);
    else {
      this.tabLinks = this.tabLinks.filter(
        (a) => a.value != "updateCredential"
      );
    }
    await this.goToTab(this.currentTab, true);
  }

  destroyed() {
    this.$store.dispatch("cancelUserForm");
  }
}
